const detectScreenArea = function (e) {
    const middleSpace = (40 / 100) * window.innerWidth;
    const leftSpace = (window.innerWidth - middleSpace) / 2;
    const rightSpace = leftSpace + middleSpace;

    if (e.clientX < leftSpace) {
        return "left";
    } else if (e.clientX >= rightSpace) {
        return "right";
    } else {
        return "center";
    }
};

export default detectScreenArea;
